import { put, takeEvery, call, fork } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import {
	setTransportsListAction,
	setIsTransportsListLoadingAction,
	setPaginationAction,
	GET_TRANSPORTS_LIST,
	setIsFiltersLoadingAction,
	setFiltersAction,
	GET_FILTERS,
} from './actions';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { errorHandler } from '../../api/utils';
import { getTransportsFilterRequest, getTransportsListRequest } from '../../api/transport';
import { notificationInit } from '../../modules/notifications/actions';
import { DISMISS_TIME } from '../../api/constants';

export function* getTransportsListSaga({ payload: { type, searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsTransportsListLoadingAction(true));
			yield put(setTransportsListAction([]));
		}

		const { data, meta, message, toast } = yield call(getTransportsListRequest, type, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setTransportsListAction(
					data.map(transport => ({
						...transport,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=${type.slice(0, -1)}&id=${transport.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsTransportsListLoadingAction(false));
	}
}

export function* getFiltersSaga({ payload: { type } }) {
	try {
		yield put(setIsFiltersLoadingAction(true));

		const { filter, message, toast } = yield call(getTransportsFilterRequest, type);

		if (filter) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setFiltersAction(filter));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsFiltersLoadingAction(false));
	}
}

export default function* transportsContainerSaga() {
	yield takeEvery(GET_TRANSPORTS_LIST, getTransportsListSaga);
	yield takeEvery(GET_FILTERS, getFiltersSaga);
}
